import React from 'react'

import { Page } from './components/page'
import { GlobalStyles } from './styles/global-styles'

export function App() {
  return (
    <>
      <GlobalStyles />
      <Page />
    </>
  )
}
